import PATHS from 'constants/paths';
import { Navigate, useParams } from 'react-router-dom';
import SurveyManage from '../SurveyContent/SurveyManage';
import SurveyResults from '../SurveyResults';

const GetSurveyCategories = () => {
  const { category } = useParams();
  switch (category) {
    case 'create':
      return <SurveyManage />;
    case 'results':
      return <SurveyResults />;
    case 'retake':
      return <div>Retake Management Component</div>;
    default:
      return <Navigate to={PATHS.NOT_FOUND} replace />;
  }
};

export default GetSurveyCategories;
